/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _ */

// render 'reason for downgrade/cancel' dropdowns, these map to Churn Risk in Salesforce.
// if possible, try not to import from here and instead pull from utils/salesforce.py
_.namespace(`mp.account`, function(exports) {
  'use strict';

  exports.missing_feature_option = `Mixpanel lacks a feature we need`;
  var reason_strings = [
    `We were not able to acquire technical resources to implement Mixpanel`,
    `We could not figure out how to implement Mixpanel`,
    exports.missing_feature_option,
    `Mixpanel takes too much time to learn/use`,
    `We aren't getting the value out of Mixpanel that we expected`,
    `Our company went out of business`,
    `We were using Mixpanel for a short project which has now ended`,
    `Our company has gone through a merger/acquisition`,
    `We no longer have budget for user analytics`,
    `Costs grew due to an increase in data volume`,
    `We are moving to different product because it is cheaper/free`,
    `We are paying for more data than we need`,
    `Someone else in my company already has a paid plan`,
  ];

  exports.reason_choices = function() {
    return _.map(reason_strings, function(value, i) {
      return [(i + 1).toString(), value];
    });
  };

  exports.competitor_option = `I have selected another vendor`;
  var analytics_alternatives_strings = [
    exports.competitor_option,
    `I no longer have a need for analytics`,
    `I have internal resources which will satisfy our analytics needs`,
    `I will continue using Mixpanel's free product`,
  ];

  exports.analytics_alternatives_choices = function() {
    return _.map(analytics_alternatives_strings, function(value, i) {
      return [(i + 1).toString(), value];
    });
  };

  exports.other_competitor = `Other`;
  var competitor_strings = [
    `Adobe Analytics`,
    `Amplitude`,
    `Customer.io`,
    `Clevertap`,
    `Firebase`,
    `Google Analytics (Free)`,
    `Google Analytics 360`,
    `Heap`,
    `Intercom`,
    `Kissmetrics`,
    `Leanplum`,
    `Pendo`,
    `Woopra`,
    exports.other_competitor,
  ];

  exports.competitor_choices = function() {
    return _.map(competitor_strings, function(value, i) {
      return [(i + 1).toString(), value];
    });
  };
});

}.call(window));